<template>
  <div :class="['emd-modal', open ? '_active' : '']">
    <div class="emd-modal__background"></div>
    <div v-if="loading" class="loading"></div>
    <div v-else class="emd-modal__wrapper">
      <!-- MODAL HEADER -->
      <div class="emd-modal__header">
        <slot name="header"></slot>
      </div>

      <div class="emd-modal__content">
        <slot name="content"></slot>
      </div>

      <!-- MODAL FOOTER -->
      <div class="emd-modal__footer">
        <slot name="footer"></slot>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Modal',
  props: {
    open: {
      type: Boolean,
      required: true,
      default: true
    },
    loading: {
      type: Boolean,
      required: true,
      default: true
    }
  }
}
</script>
<style scoped>
  .emd-modal {
    z-index: 10;
  }
  .c-modal__alert {
    bottom: 0;
    display: none;
    left: 0;
    margin: auto;
    max-width: 500px;
    max-height: 100px;
    position: absolute;
    right: 0;
    top: 0;
  }
  .loading {
    pointer-events: none
  }
  .loading:before {
    animation: spin 2s linear infinite;
    border: 5px solid #f3f3f3;
    border-top: 5px solid #00b7b4;
    border-radius: 50%;
    bottom: 0;
    content: '';
    height: 40px;
    left: 0;
    margin: auto;
    position: absolute;
    right: 0;
    top: 0;
    width: 40px;
    z-index: 2;
  }
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
</style>
